<script setup lang="ts">
import {apiRegisterOrLConfirmPhoneMask, apiRegisterOrLoginPhoneMask} from "~/composables/api/auth/auth";
import {useFormValidation} from "~/composables/validations/useFormValidation";

const { t } = useI18n()
const form = useStoreOrderClientForm()

const error = ref({
  isError: false,
  text: ''
})

const {$toast, $toastError} = useNuxtApp()
const verifyCode = ref('')

const isClickedSendCode = ref(false)
const {
  errors,
  validateName, validateLastName
} = useFormValidation()

const emit = defineEmits(['successEvent'])

function handleClick() {
  if (!isClickedSendCode.value) {
    handleLogin()
  } else {
    handleConfirm()
  }
}

async function handleLogin() {
  validate()
  if (error.value.isError) {
    return
  }
  if (!isClickedSendCode.value) {
    $toast(t('messages.auth.success.receive_code'))
  }
  isClickedSendCode.value = true

  const response = await apiRegisterOrLoginPhoneMask(form.value.phone_number);
  if (!response.status) {
    $toastError(t('messages.auth.error.receive_code'))
  }
}


async function handleConfirm() {
  validate()
  if (error.value.isError) {
    return
  }
  if (verifyCode.value.length === 4) {
    const response = await apiRegisterOrLConfirmPhoneMask(form.value.phone_number, verifyCode.value, form.value.first_name)
    if (response.status) {
      $toast(t('messages.success.confirm'))
      emit('successEvent')
    } else {
      error.value = {
        isError: true,
        text: t('messages.auth.error.invalid_code')
      }
    }
  } else {
    error.value = {
      isError: true,
      text: t('messages.auth.error.enter_code')
    }
  }
}

function validate() {
  if (!form.value.phone_number) {
    error.value = {
      isError: true,
      text: t('messages.auth.error.enter_phone')
    }
    return
  }
  if (form.value.phone_number.length < 16) {
    error.value = {
      isError: true,
      text: t('messages.auth.error.invalid_phone')
    }
    return
  }
  error.value = {
    isError: false,
    text: ''
  }
}
</script>

<template>
  <div class="flex gap-3 flex-col">
    <div>
      <p class="text-sm text-secondary-800 mb-2">{{ $t('input_forms.field.phone.placeholder') }}</p>
      <UIInput
          v-model="form.phone_number"
          type="tel"
          mask="+7(###)###-##-##"
          placeholder="+7 (---) --- -- --"
          class="rounded-[6px] bg-white border border-neutral-light-gray"
      />
    </div>
    <div v-if="isClickedSendCode" class="w-fit">
      <p class="text-sm text-secondary-800 mb-2">{{ $t('input_forms.field.verification_code.placeholder') }}</p>
      <UIInput
          v-model="verifyCode"
          type="tel"
          mask="####"
          placeholder=""
          class="rounded-[6px] bg-white border border-neutral-light-gray "
      />
    </div>
    <p v-if="error.isError" class="text-primary-red text-sm">{{ error.text }}</p>
    <UIBtn
        @click="handleClick"
        color="green"
        class="w-fit h-fit ml-auto"
    >
      {{ $t('input_forms.button.confirm') }}
    </UIBtn>
  </div>
</template>

<style scoped>

</style>